import QueryString from './QueryString.js';

/**
 * Gets all headers and returns a dictionary mapping each response header.
 */
function splitResponseHeaders(xhr) {

    var lines = xhr.getAllResponseHeaders().trim().split('\n');

    var headers = {};
    lines.forEach((line) => {
        var idx = line.indexOf(':');
        var name = line.substr(0, idx).toLowerCase();
        var value = line.substr(idx + 1);
        // Known Conversions
        if (name === 'last-modified') value = new Date(value);
        if (name === 'date') value = new Date(value);
        headers[name] = value;
    });

    return headers;
}

let DefaultOptions = {

    GET: {
        responseType: "" // text?
    },

    POST: {

    }
};

function makeXHR(type, path, data, options, defOpts) {

    // 
    options = Object.assign({}, defOpts, options);

    // Returns a promise for the xhr request
    return new Promise((resolve, reject) => {

        // Convert data to query string, and append to url
        if (type === 'GET' || type === 'HEAD') {
            if (data) {
                var query = QueryString.Encode(data);
                path = path + "?" + query;
            }
        }

        // Create Request
        var xhr = new XMLHttpRequest();
        xhr.open(type, path, true);

        // Configure XHR Object
        if (options.responseType !== undefined)
            xhr.responseType = options.responseType;

        // Configure Request Headers
        if (options.headers) {
            for (let name in options.headers)
                xhr.setRequestHeader(name, options.headers[name]);
        }

        // Configure Load Response
        xhr.onload = function (e) {
            var self = this;

            // 200 OK
            if (this.status == 200) {

                // Success, return response object
                resolve({
                    headers: splitResponseHeaders(self),
                    data: this.response,
                    path: path
                });

            } else {

                // Failure, return error code
                reject({
                    headers: splitResponseHeaders(self),
                    message: self.statusText,
                    status: self.status
                });
            }
        }

        // Send
        xhr.send(type == 'POST' ? data : null);
    });
}

export default {

    /**
     * Performs a http GET request.
     */
    get(url, data, options) {
        return makeXHR('GET', url, data, options, DefaultOptions.GET);
    },

    /**
     * Performs a http HEAD request.
     */
    head(url, data, options) {
        return makeXHR('HEAD', url, data, options, DefaultOptions.HEAD);
    },

    /**
     * Performs a http POST request.
     */
    post(url, data, success, error) {
        return makeXHR('POST', url, data, options, DefaultOptions.HEAD);
    }
};